import { TrailVisual } from './TrailVisual';
import type { VisualSample } from './types';

export class RibbonVisual extends TrailVisual {
  constructor(){ super(42); }
  draw(ctx: CanvasRenderingContext2D, w:number, h:number, s:VisualSample){
    super.draw(ctx,w,h,s);
    const wrists=[s.left,s.right].filter(Boolean);
    wrists.forEach((p,i)=>{
      if(!p) return;
      const hue=i?325:188;
      const radius=26+s.movement.movementEnergy*56;
      const gradient=ctx.createRadialGradient(p.x*w,p.y*h,2,p.x*w,p.y*h,radius);
      gradient.addColorStop(0,`hsla(${hue},100%,78%,.72)`); gradient.addColorStop(1,`hsla(${hue},100%,58%,0)`);
      ctx.fillStyle=gradient; ctx.beginPath(); ctx.arc(p.x*w,p.y*h,radius,0,Math.PI*2); ctx.fill();
    });
  }
}
